const PURCHASED_PHOTO_PRICING_STATUS = {
  PENDING: 'PENDING',
  SHIPPED: 'SHIPPED',
};

export { PURCHASED_PHOTO_PRICING_STATUS };
